import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { api } from '../lib/api';
import SafeIcon from '../common/SafeIcon';

export default function DeviceRedirect() {
  const { serial } = useParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState('searching'); // searching, unlinked, error

  useEffect(() => {
    const resolveDevice = async () => {
      try {
        // The server finds the device, its owner and any active custom domain.
        const result = await api.get(`public/device/${encodeURIComponent(serial.toUpperCase())}`);

        if (result.status !== 'linked') {
          setStatus(result.status === 'unlinked' ? 'unlinked' : 'error');
          return;
        }

        if (result.hostname) {
          // Redirect to the custom domain (root)
          window.location.href = `https://${result.hostname}`;
        } else {
          // Fallback: Redirect to the platform profile URL
          navigate(`/p/${result.username}`, { replace: true });
        }
      } catch (err) {
        console.error("Redirection error:", err);
        setStatus('error');
      }
    };

    if (serial) {
      resolveDevice();
    }
  }, [serial, navigate]);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-white px-4 text-center">
      {status === 'searching' && (
        <>
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-indigo-600 mb-4"></div>
          <p className="text-gray-500 font-medium">Connecting to profile...</p>
        </>
      )}

      {status === 'unlinked' && (
        <div className="max-w-md">
          <div className="w-20 h-20 bg-indigo-100 rounded-full flex items-center justify-center text-indigo-600 mx-auto mb-6">
            <SafeIcon name="Smartphone" className="text-3xl" />
          </div>
          <h1 className="text-2xl font-bold text-gray-900 mb-2">New TapBadge Detected!</h1>
          <p className="text-gray-500 mb-8">
            This device hasn't been activated yet. If you own this badge, log in to your account and enter code
            <span className="block mt-2 font-mono text-xl font-bold text-indigo-600 tracking-widest">{serial.toUpperCase()}</span>
          </p>
          <button
            onClick={() => navigate('/login')}
            className="bg-indigo-600 text-white px-8 py-3 rounded-xl font-bold hover:bg-indigo-700 transition-all"
          >
            Log In to Activate
          </button>
        </div>
      )}

      {status === 'error' && (
        <div className="max-w-md">
          <div className="w-20 h-20 bg-red-100 rounded-full flex items-center justify-center text-red-600 mx-auto mb-6">
            <SafeIcon name="AlertTriangle" className="text-3xl" />
          </div>
          <h1 className="text-2xl font-bold text-gray-900 mb-2">Invalid Device</h1>
          <p className="text-gray-500 mb-8">This TapBadge code is not recognized by our system.</p>
          <button
            onClick={() => navigate('/')}
            className="text-indigo-600 font-bold hover:underline"
          >
            Go to Homepage
          </button>
        </div>
      )}
    </div>
  );
}
